import { MLHelper } from '@bimser/core';
import { Map } from 'immutable';
import { DmDataFactoryFromJS } from '../../entities/IDmData';

export function* GenerateDmData(data: any) {
	return GenerateDmModel(data);
}

export function GenerateDmModel(data: any) {
	const name = MLHelper.getMLText(data.name);
	const description = MLHelper.getMLText(data.description);
	let meta = Map<string, any>()
		.set('NAME', name)
		.set('CREATEDAT', data.createdAt)
		.set('ID', data.id.toString())
		.set('SECRETKEY', data.secretKey)
		.set('OWNER', data.createdBy?.name)
		.set('DESCRIPTION', description || '')
		.set('VERSION', data.version)
		.set('MODIFIEDAT', data.modifiedAt || '')
		.set('VERSIONDATE', data.versionDate)
		.set('TYPE', data.type)
		.set('TAGS', data.tags)
		.set('CATEGORY', data.category);

	if (data.metaDataFieldsValues?.length) {
		data.metaDataFieldsValues.forEach((field: any) => {
			meta = meta.update(`metadatafieldvalue_${field.formId}_${field.fieldName}`, () => {
				switch (field.fieldValue.type) {
					case 13:
						return JSON.parse(field.fieldValue.value || '[]');
					case 9:
						return JSON.parse(field.fieldValue.text || '[]').toLocaleString();
					default:
						return field.fieldValue.text;
				}
			});
		});
	}

	return DmDataFactoryFromJS({
		id: data.id.toString(),
		metadata: meta,
		name: name,
		secretKey: data.secretKey,
		type: data.type,
		path: description,
		createdBy: data.createdBy,
		modifiedBy: data.modifiedBy,
		deletedBy: data.deletedBy,
		originType: data.originType ? data.originType : data.type,
		version: data.version,
		versionId: data.versionId,
		versionSecretKey: data.versionSecretKey,
		versionDate: data.versionDate,
		existThumbnail: data.existThumbnail,
		recentCreatedAt: data.recentCreatedAt,
		tags: data.tags,
		category: data.category
	});
}
